export default {
    users: {
        users: undefined,
        loading: false,
        noContent: false,
        error: false,
        list: {
            page: undefined,
            maxPages: undefined,
            itemsPerPage: undefined,
            order: undefined,
            orderBy: undefined,
            orderValues: ['asc', 'desc'],
            orderByValues: ['name', 'active'],
            filter: undefined,
        }
    },
    notifications: {
        loading: false,
        error: false,
        noContent: false,
        items: {},
        admin: undefined,
        original: undefined,
    },
    roles: {
        roles: undefined,
        loading: false,
        error: false,
        noContent: false,
    },
    languages: {
        languages: undefined,
        loading: false,
        error: false,
        noContent: false,
    },
    createModal: {
        open: false,
        user: {
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            language: 'en', // Default language is English,
            roles: []
        },
        form: {
            submitted: false,
            accepted: false,
            loading: false,
            success: false,
            error: false
        }
    },
    editModal: {
        open: false,
        user: undefined,
        originalUser: undefined,
        form: {
            submitted: false,
            accepted: false,
            loading: false,
            success: false,
            error: false
        }
    },
    tips: [
        {
            title: 'tips.adminPage.create.title',
            body: 'tips.adminPage.create.body'
        },
        {
            title: 'tips.adminPage.edit.title',
            body: 'tips.adminPage.edit.body'
        },
        {
            title: 'tips.adminPage.block.title',
            body: 'tips.adminPage.block.body'
        }
    ]
};



// WEBPACK FOOTER //
// ./src/store/modules/admin/state.js